import I from "../tilecache/TileCache.js";
import f from "../maps/WarpedMapList.js";
import c from "../tilecache/FetchableTile.js";
import { WarpedMapEvent as l, WarpedMapEventType as o } from "../shared/events.js";
import { getBestTileZoomLevelForScale as E, computeTilesCoveringRingAtTileZoomLevel as T, getTilesResolution as L, getTileZoomLevelResolution as R, getTilesAtScaleFactor as A } from "../shared/tiles.js";
import { computeBbox as g, webMercatorToLonLat as O, squaredDistance as w, bboxToCenter as v, bboxToDiameter as F } from "@allmaps/stdlib";
const V = 5, m = 0, b = 2, C = 4, M = 10, D = 0, P = 0.4, B = 1024 * 1024, W = 10;
class U extends EventTarget {
  warpedMapList;
  tileCache;
  mapsInViewport = /* @__PURE__ */ new Set();
  mapsWithRequestedTilesForViewport = /* @__PURE__ */ new Set();
  viewport;
  constructor(e, a, r) {
    super(), this.tileCache = new I(e, r), this.warpedMapList = new f(a, r);
  }
  /**
   * Parses an annotation and adds its georeferenced map to this renderer's warped map list
   *
   * @async
   * @param {unknown} annotation
   * @returns {Promise<(string | Error)[]>}
   */
  async addGeoreferenceAnnotation(e) {
    return this.warpedMapList.addGeoreferenceAnnotation(e);
  }
  /**
   * Adds a georeferenced map to this renderer's warped map list
   *
   * @async
   * @param {unknown} georeferencedMap
   * @returns {Promise<string | Error>}
   */
  async addGeoreferencedMap(e) {
    return this.warpedMapList.addGeoreferencedMap(e);
  }
  loadMissingImageInfosInViewport() {
    return this.viewport ? Array.from(
      this.warpedMapList.getMapsByGeoBbox(this.viewport.geoRectangleBbox)
    ).map((e) => this.warpedMapList.getWarpedMap(e)).filter(
      (e) => !e.hasImageInfo() && !e.loadingImageInfo
    ).map((e) => e.loadImageInfo()) : [];
  }
  someImageInfosInViewport() {
    return this.viewport ? Array.from(
      this.findMapsInViewport(
        this.shouldAnticipateInteraction() ? M : 0
      )
    ).map((e) => this.warpedMapList.getWarpedMap(e)).map((e) => e.hasImageInfo()).some(Boolean) : !1;
  }
  shouldRequestFetchableTiles() {
    return !0;
  }
  // Should we anticipate user interaction (panning or zooming)
  // and hence buffer the viewport or get overview tiles
  shouldAnticipateInteraction() {
    return !1;
  }
  requestFetchableTiles() {
    if (!this.shouldRequestFetchableTiles())
      return;
    const e = [], a = [], r = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? m : 0
    ), t = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? b : 0
    ), n = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? C : 0
    ), i = this.findMapsInViewport(
      this.shouldAnticipateInteraction() ? M : 0
    );
    for (const s of this.warpedMapList.getWarpedMaps())
      s.resetCurrent();
    for (const s of n)
      e.push(
        ...this.getMapFetchableTilesForViewport(s, r)
      );
    if (this.shouldAnticipateInteraction())
      for (const s of i)
        a.push(
          ...this.getMapOverviewFetchableTilesForViewport(
            s,
            [
              ...e,
              ...a
            ],
            t
          )
        );
    this.tileCache.requestFetchableTiles([
      ...e,
      ...a
    ]), this.updateMapsForViewport([
      ...e,
      ...a
    ]), this.pruneTileCache(i);
  }
  findMapsInViewport(e = 0) {
    if (!this.viewport)
      return /* @__PURE__ */ new Set();
    const a = this.viewport, r = this.viewport.getProjectedGeoBufferedRectangle(e), t = g(
      r.map((n) => O(n))
    );
    return new Set(
      Array.from(
        this.warpedMapList.getMapsByGeoBbox(t)
      ).sort((n, i) => {
        const s = this.warpedMapList.getWarpedMap(n), p = this.warpedMapList.getWarpedMap(i);
        return s && p ? w(
          v(s.geoMaskBbox),
          a.geoCenter
        ) - w(
          v(p.geoMaskBbox),
          a.geoCenter
        ) : 0;
      })
    );
  }
  getMapFetchableTilesForViewport(e, a) {
    if (!this.viewport)
      return [];
    const r = this.viewport, t = this.warpedMapList.getWarpedMap(e);
    if (!t)
      return [];
    if (!t.visible)
      return [];
    if (!t.hasImageInfo())
      return [];
    if (F(t.getViewportMaskBbox(r)) < V)
      return [];
    const n = E(
      t.parsedImage.tileZoomLevels,
      t.getResourceToCanvasScale(r),
      D,
      P
    );
    t.setCurrentTileZoomLevel(n), t.setCurrentBestScaleFactor(n.scaleFactor);
    const i = {
      maxDepth: 0,
      // maxDepth: 2,
      // maxOffsetRatio: 0.00001,
      sourceIsGeographic: !1,
      destinationIsGeographic: !0
    }, s = t.projectedTransformer.transformBackward(
      [
        r.getProjectedGeoBufferedRectangle(
          this.shouldAnticipateInteraction() ? m : 0
        )
      ],
      i
    )[0];
    if (t.setCurrentResourceViewportRing(s), !a.has(e))
      return [];
    const h = T(
      s,
      n,
      [t.parsedImage.width, t.parsedImage.height]
    ).map(
      (d) => new c(d, t)
    );
    return t.setCurrentFetchableTiles(h), h;
  }
  getMapOverviewFetchableTilesForViewport(e, a, r) {
    if (!this.viewport)
      return [];
    const t = this.warpedMapList.getWarpedMap(e);
    if (!t)
      return [];
    if (!t.visible)
      return [];
    if (!t.hasImageInfo())
      return [];
    const n = L(
      a.map((d) => d.tile)
    ), i = this.viewport.canvasResolution * W;
    if (n > i)
      return [];
    const s = t.parsedImage.tileZoomLevels.filter(
      (d) => R(d) <= B
      // Neglect zoomlevels that contain too many pixels
    ).sort(
      (d, u) => d.scaleFactor - u.scaleFactor
      // Enforcing default ascending order, e.g. from 1 to 16
    ).at(-1);
    if (t.setCurrentOverviewTileZoomLevel(s), !r.has(e))
      return [];
    if (!s || t.currentTileZoomLevel && s.scaleFactor <= t.currentTileZoomLevel.scaleFactor)
      return [];
    const h = A(
      s.scaleFactor,
      t.parsedImage
    ).map(
      (d) => new c(d, t)
    );
    return t.setCurrentOverviewFetchableTiles(h), h;
  }
  updateMapsForViewport(e) {
    this.mapsWithRequestedTilesForViewport = new Set(
      e.map((i) => i.mapId).filter((i, s, p) => p.indexOf(i) === s).sort((i, s) => {
        const p = this.warpedMapList.getMapZIndex(i), h = this.warpedMapList.getMapZIndex(s);
        return p !== void 0 && h !== void 0 ? p - h : 0;
      })
    ), this.mapsInViewport = this.findMapsInViewport();
    const a = Array.from(this.mapsInViewport), r = Array.from(this.mapsInViewport), t = r.filter(
      (i) => !a.includes(i)
    ), n = a.filter(
      (i) => !r.includes(i)
    );
    for (const i of t)
      this.dispatchEvent(
        new l(o.WARPEDMAPENTER, i)
      );
    for (const i of n)
      this.clearMap(i), this.dispatchEvent(
        new l(o.WARPEDMAPLEAVE, i)
      );
  }
  pruneTileCache(e) {
    const a = /* @__PURE__ */ new Map();
    for (const r of this.warpedMapList.getWarpedMaps(
      e
    ))
      a.set(r.mapId, {
        currentTileZoomLevel: r.currentTileZoomLevel,
        currentOverviewTileZoomLevel: r.currentOverviewTileZoomLevel,
        currentResourceViewportRingBbox: r.currentResourceViewportRingBbox
      });
    this.tileCache.prune(a);
  }
  destroy() {
    this.tileCache.destroy(), this.warpedMapList.destroy();
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  clearMap(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  mapTileLoaded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  mapTileRemoved(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  imageInfoLoaded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  warpedMapAdded(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  warpedMapRemoved(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  preChange(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  transformationChanged(e) {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  distortionChanged(e) {
  }
  addEventListeners() {
    this.tileCache.addEventListener(
      o.MAPTILELOADED,
      this.mapTileLoaded.bind(this)
    ), this.tileCache.addEventListener(
      o.MAPTILEREMOVED,
      this.mapTileRemoved.bind(this)
    ), this.warpedMapList.addEventListener(
      o.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    ), this.warpedMapList.addEventListener(
      o.WARPEDMAPADDED,
      this.warpedMapAdded.bind(this)
    ), this.warpedMapList.addEventListener(
      o.WARPEDMAPREMOVED,
      this.warpedMapRemoved.bind(this)
    ), this.warpedMapList.addEventListener(
      o.PRECHANGE,
      this.preChange.bind(this)
    ), this.warpedMapList.addEventListener(
      o.TRANSFORMATIONCHANGED,
      this.transformationChanged.bind(this)
    ), this.warpedMapList.addEventListener(
      o.DISTORTIONCHANGED,
      this.distortionChanged.bind(this)
    );
  }
  removeEventListeners() {
    this.tileCache.removeEventListener(
      o.MAPTILELOADED,
      this.mapTileLoaded.bind(this)
    ), this.tileCache.removeEventListener(
      o.MAPTILEREMOVED,
      this.mapTileRemoved.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.IMAGEINFOLOADED,
      this.imageInfoLoaded.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.WARPEDMAPADDED,
      this.warpedMapAdded.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.WARPEDMAPREMOVED,
      this.warpedMapRemoved.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.PRECHANGE,
      this.preChange.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.TRANSFORMATIONCHANGED,
      this.transformationChanged.bind(this)
    ), this.warpedMapList.removeEventListener(
      o.DISTORTIONCHANGED,
      this.distortionChanged.bind(this)
    );
  }
}
export {
  U as default
};
//# sourceMappingURL=BaseRenderer.js.map
